import { DEBUG_MODE_ENABLED } from '../settings';

export function info(...args: any) {
  if (DEBUG_MODE_ENABLED) {
    console.info(...args);
  }
}
